/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * 
 * @export
 * @interface EntityNode
 */
export interface EntityNode {
    /**
     * 
     * @type {string}
     * @memberof EntityNode
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof EntityNode
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EntityNode
     */
    url?: string;
    /**
     * 
     * @type {Array<Value>}
     * @memberof EntityNode
     */
    propertyValues: Array<Value>;
    /**
     * Whether or not the node should be highlighted, usually when this node contains the current entity
     * @type {boolean}
     * @memberof EntityNode
     */
    highlighted: boolean;
    /**
     * The hierarchy level the node is on, the top parent has level 1, children have levels 1+
     * @type {number}
     * @memberof EntityNode
     */
    level: number;
    /**
     * The count of missing child connections (i.e. direct children)
     * @type {number}
     * @memberof EntityNode
     */
    missingChildrenCount?: number;
    /**
     * The count of missing parent connections (i.e. direct parents)
     * @type {number}
     * @memberof EntityNode
     */
    missingParentsCount?: number;
    /**
     * Reference to node type, usually only set if the hierarchy consists of multiple entities aka types
     * @type {string}
     * @memberof EntityNode
     */
    typeId?: string;
}

/**
 * Check if a given object implements the EntityNode interface.
 */
export function instanceOfEntityNode(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "propertyValues" in value;
    isInstance = isInstance && "highlighted" in value;
    isInstance = isInstance && "level" in value;

    return isInstance;
}

export function EntityNodeFromJSON(json: any): EntityNode {
    return EntityNodeFromJSONTyped(json, false);
}

export function EntityNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'id': json['id'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'propertyValues': ((json['propertyValues'] as Array<any>).map(ValueFromJSON)),
        'highlighted': json['highlighted'],
        'level': json['level'],
        'missingChildrenCount': !exists(json, 'missingChildrenCount') ? undefined : json['missingChildrenCount'],
        'missingParentsCount': !exists(json, 'missingParentsCount') ? undefined : json['missingParentsCount'],
        'typeId': !exists(json, 'typeId') ? undefined : json['typeId'],
    };
}

export function EntityNodeToJSON(value?: EntityNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'id': value.id,
        'url': value.url,
        'propertyValues': ((value.propertyValues as Array<any>).map(ValueToJSON)),
        'highlighted': value.highlighted,
        'level': value.level,
        'missingChildrenCount': value.missingChildrenCount,
        'missingParentsCount': value.missingParentsCount,
        'typeId': value.typeId,
    };
}

